import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

// Stripe Products service

@Injectable({ providedIn: 'root' })
export class ProductsService {
    constructor(private http: HttpClient) { }

    // paginated
    getProducts(filter?: any): Observable<any> {
        return this.http.post(`${environment.apiUrl}products`, filter);
    }

    // without pagination
    getAllProducts(): Observable<any> {
        return this.http.get(`${environment.apiUrl}products/all`);
    }

    // create new and archive existing on stripe + update db
    createProduct(data: any): Observable<object> {
        return this.http.post(`${environment.apiUrl}products/create`, data);
    }

    // create new and archive existing on stripe + update db
    updateProduct(id: string, data: any): Observable<object> {
        return this.http.put(`${environment.apiUrl}products/update/${id}`, data);
    }

    // delete from db + archive on stripe
    deleteProduct(id: string): Observable<void> {
        return this.http.delete<void>(
            `${environment.apiUrl}products/delete/${id}`
        );
    }
}
